<template lang="pug">
    v-dialog(
        v-model="isOpen"
        width="520"
        persistent
    )
        div.dialogWrapper
            v-form.c-form(autocomplete="off" @submit.prevent="submit")
                v-container(fluid grid-list-lg)
                    v-layout.align-center(raw wrap)

                        v-flex(xs10)

                            // Title
                            title-component(:title="$t('users.setPassword.title')" type="h3")

                        v-flex.text-xs-right.mb-2(xs2)

                            // Close
                            button-icon(:action="cancel" color="white" icon="close")

                        v-flex(xs12)

                            // Explanation
                            p.description {{ $t('users.setPassword.description') }}

                        v-flex(xs12)

                            // Password field
                            v-text-field(
                                :error-messages="errors.collect('password')"
                                :data-vv-as="$t('users.setPassword.passwordField')"
                                :label="$t('users.setPassword.passwordField')"
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                :type="showPassword ? 'text' : 'password'"
                                :disabled="isSaving"
                                name="password"
                                autocomplete="new-password"
                                v-model="form.password"
                                v-validate="'required|min:6|max:72'"
                                outline
                                @click:append="showPassword = !showPassword"
                            )

                        v-flex(xs12)

                            separator-component

                            div.controls
                                div

                                    // Cancel
                                    button-component.ml-0(
                                        :action="cancel"
                                        :isLoading="isSaving"
                                        :disabled="isSaving"
                                        color="grey"
                                        large
                                        outline
                                    ) {{ $t('users.setPassword.cancel') }}

                                div

                                    // Save
                                    button-component.mr-0.submit(
                                        :action="submit"
                                        :isLoading="isSaving"
                                        :disabled="isSaving"
                                        color="white"
                                        large
                                    ) {{ $t('users.setPassword.save') }}
</template>

<script>
    import VueTypes from 'vue-types';
    import users from '~api/users';
    import { Handler } from '~services';
    import Button from '~components/Button';
    import ButtonIcon from '~components/ButtonIcon';
    import Separator from '~components/Separator';
    import Title from '~components/Title';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonIcon,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        props: {
            value: VueTypes.bool.def(false),
            userId: VueTypes.oneOfType([String, Number]).def('')
        },
        data() {
            return {
                form: {
                    password: ''
                },
                showPassword: false,
                isSaving: false
            };
        },
        computed: {
            isOpen: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },
        watch: {
            value(opened) {
                if (opened) {
                    this.reset();
                }
            }
        },
        methods: {
            reset() {
                this.form.password = '';
                this.showPassword = false;
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },

            cancel() {
                this.isOpen = false;
            },

            async submit() {
                if (this.isSaving) return;

                const isValid = await this.$validator.validateAll();
                if (!isValid || !this.userId) return;

                this.isSaving = true;
                try {
                    const resp = await users.setPassword(this.userId, {
                        password: this.form.password
                    });

                    Handler.handleResponse(
                        resp,
                        this.$t('users.setPassword.successMessage')
                    );

                    if (resp && resp.ok) {
                        this.isOpen = false;
                    }
                } finally {
                    this.isSaving = false;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl';

    .dialogWrapper
        background: $theme.primary

    .description
        color: white
        opacity: 0.85
</style>
